import { SaleOrderStatus } from "../shared/enums/sale-order-status.enum";

export enum ConstantValues {
    VolumaticWeightDivider = 5000,
    VolumaticOceanWeightDivider = 1000000,
}

export const deliveredStatuses: SaleOrderStatus[] = [
    // Legacy Status
    SaleOrderStatus.DELIVERED,

    // AfterShip Standard Delivered
    SaleOrderStatus.DELIVERED_001, // Delivered
    
    // Delivery to Point / Pickup
    SaleOrderStatus.DELIVERED_002, // Picked up by the customer
    
    // Signed/Verified Deliveries
    SaleOrderStatus.DELIVERED_003, // Sign by customer
    
    // Financial Completion Deliveries
    SaleOrderStatus.DELIVERED_004  // Delivered and received cash on delivery
];

export function isDeliveredSaleOrderStatus(
    status: SaleOrderStatus | number | string | null | undefined,
): boolean {
    if (status === null || status === undefined || status === '') {
        return false;
    }
    const normalized = Number(status);
    if (Number.isNaN(normalized)) {
        return false;
    }
    return deliveredStatuses.includes(normalized as SaleOrderStatus);
}

export function isDeliveredSaleOrderStatusName(
    statusName: string | null | undefined,
): boolean {
    if (!statusName) {
        return false;
    }
    const upper = statusName.toUpperCase();
    if (upper === 'DELIVERED') {
        return true;
    }
    const statusId = SaleOrderStatus[upper as keyof typeof SaleOrderStatus];
    return isDeliveredSaleOrderStatus(typeof statusId === 'number' ? statusId : undefined);
}
